module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/univ-kentucky-53af1ffbad7ce1b91619a34ee3fea64d.svg";